module.exports = __webpack_public_path__ + "media/images/bookings/childcare/pro_recommendation_sticker-db8f8d4264101c971b6d763bc41f4ae8.png";